import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

import { GlobalService } from '../../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TaskSearchService {
  taskSearchResults: any = [];
  search(url?, crit?) {
    const api = url || (<any>_GlobalNS).api.task.search;
    const heads = {};
    const headers = new HttpHeaders(heads);
    const params = crit;
    return this._http.get(`${api}`, { headers: headers, params: params });
  }

  constructor(private _http: HttpClient, private _global: GlobalService) { }
  getTaskViewUri(eventlocation: string, property_id: number, eventTrackingID: number, event_tracking_parent?: number): string {
    let buildUri = `${eventlocation}&property_id=${property_id}&eventTrackingID=${eventTrackingID}`;
    buildUri = (event_tracking_parent !== null) ? `${buildUri}&event_tracking_parent=${event_tracking_parent}` : buildUri;
    return (<any>_GlobalNS).api.baseEvent + buildUri;
  }
  exportToExcel(url?, crit?) {
    const api = url || (<any>_GlobalNS).api.task.buildExcel;
    const heads = {};
    const headers = new HttpHeaders(heads);
    const params = crit;
    return this._http.get(`${api}`, { headers: headers, params: params });
  }
}
